import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { UiService } from '@services/ui.service';
import { OrderCreateMode, OrderCreateModeService } from '@services/order-create-mode.service';

@Injectable({
  providedIn: 'root'
})
export class OrderCreateModeGuard {
  constructor(
    private orderCreateModeSrv: OrderCreateModeService,
    private router: Router,
    private uiSrv: UiService
  ) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const mode = route.data.mode as OrderCreateMode;

    return this.orderCreateModeSrv.getAccessibleSites().pipe(
      map(sites => {
        if (this.orderCreateModeSrv.hasSitesForMode(sites, mode)) {
          return true;
        }

        this.uiSrv.showSnackbar('orders.create.unavailableMode', true);
        this.router.navigate(['/orders/list']);
        return false;
      }),
      catchError(() => {
        this.router.navigate(['/orders/list']);
        return of(false);
      })
    );
  }
}